export const MAX_DESCRIPTION_LEN = 5000;
export const MAX_TITLE_LEN = 200;
